module.exports = __webpack_public_path__ + "static/media/Andrea Martinez Headshot.ff69a7a7.jpeg";